import React, {useEffect} from 'react';
import {storage} from "../../utils/Storage";


function ConfigPage({children}) {

    useEffect(() => {
        storage.clearPageData();
        //退出时清理页面数据
        return () => {
            storage.clearPageData();
        };
    }, []);

    return (
        children
    );
}

export default ConfigPage;

